import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { fetchFeatures } from "../../../components/Service/ProductService";

const Backups = ({ onSelectedfeatures, priceAdd }) => {
    const [features, setFeatures] = useState([]);
    const [selectedFeatures, setSelectedFeatures] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [checkboxChecked, setCheckboxChecked] = useState(false);
    const [featureToRemove, setFeatureToRemove] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const data = await fetchFeatures();
            setFeatures(data);

            if (data.length > 0) {
                setSelectedFeatures([data[0]]);
                onSelectedfeatures([data[0]]);
            }
        };
        fetchData();
    }, []);

    const handleSelectFeature = (id) => {
        setSelectedFeatures((prevSelected) => {
            const isSelected = prevSelected.some((feature) => feature.id === id);

            if (isSelected && id === features[0]?.id) {
                setFeatureToRemove(features[0]);
                setShowModal(true);
                return prevSelected;
            }

            const updatedSelected = isSelected
                ? prevSelected.filter((feature) => feature.id !== id)
                : [...prevSelected, features.find((feature) => feature.id === id)];

            onSelectedfeatures(updatedSelected);
            return updatedSelected;
        });
    };

    const handleConfirmDisable = () => {
        setSelectedFeatures((prevSelected) =>
            prevSelected.filter((feature) => feature.id !== featureToRemove.id)
        );
        setFeatureToRemove(null);
        setShowModal(false);
        setCheckboxChecked(false);
        onSelectedfeatures(selectedFeatures.filter((feature) => feature.id !== featureToRemove.id));
    };

    const handleCloseModal = () => {
        setFeatureToRemove(null);
        setShowModal(false);
        setCheckboxChecked(false);
    };

    const handleCheckboxChange = (event) => {
        setCheckboxChecked(event.target.checked);
    };

    return (
        <div style={{ margin: 0, padding: 0 }} className="container mt-4">
            <div className="row">
                {features.map((feature, index) => (
                    <div className="col-md-4 mb-3" key={feature.id}>
                        <div
                            className={`card ${selectedFeatures.some((f) => f.id === feature.id) ? "border-selected" : ""}`}
                            style={{
                                border: selectedFeatures.some((f) => f.id === feature.id) ? "1px solid #0069ff" : "", height: "100%",
                                cursor: "pointer"
                            }}
                            onClick={() => handleSelectFeature(feature.id)}
                        >
                            <div className="card-body">
                                <h5
                                    className="card-title d-flex justify-content-between"
                                    style={{ fontSize: "1rem" }}
                                >
                                    {feature.title}
                                    {feature.recommended && (
                                        <span className="badge bg-primary" style={{ fontSize: "0.8rem" }}>
                                            Recommended
                                        </span>
                                    )}
                                </h5>
                                {index === 0 && (
                                    <h6 className="card-subtitle mb-2 text-muted" style={{ fontSize: "1rem" }}>
                                        {(priceAdd).toLocaleString("vi-VN")}/tháng
                                    </h6>
                                )}
                                {index !== 0 && (
                                    <h6 className="card-subtitle mb-2 text-muted" style={{ fontSize: "1rem" }}>
                                        {feature.price}
                                    </h6>
                                )}
                                <p className="card-text" style={{ fontSize: "0.8rem" }}>
                                    {feature.description}
                                </p>
                                {feature.link && (
                                    <a href="#" className="card-link" style={{ fontSize: "0.8rem" }}>
                                        {feature.link}
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>

            {showModal && (
                <div className="modal fade show" style={{ display: "block", marginTop: "100px" }} role="dialog">
                    <div className="modal-dialog modal-lg" style={{ width: "50%" }}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">
                                    Are you sure you want to continue disabling Auto Backups?                                </h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleCloseModal}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <p>You will lose all these benefits without having Auto Backups enabled:</p>
                                <ul>
                                    <li className="text-danger">
                                        <strong>Peace of Mind:</strong>
                                    </li>
                                    <li className="text-danger">
                                        <strong>Scalability:</strong>
                                    </li>
                                    <li className="text-danger">
                                        <strong>Fast and Easy Disaster Recovery:</strong>
                                    </li>
                                </ul>
                                <div className="form-check mt-3">
                                    <input
                                        style={{ border: "1px solid black" }}
                                        type="checkbox"
                                        className="form-check-input"
                                        id="understandRisk"
                                        onChange={handleCheckboxChange}
                                    />
                                    <label className="form-check-label" htmlFor="understandRisk">
                                        I understand the risks.

                                    </label>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    style={{ backgroundColor: "#BE2E30" }}
                                    disabled={!checkboxChecked}
                                    onClick={handleConfirmDisable}
                                    color="white"
                                >
                                    Disable Auto Backups
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleCloseModal}
                                >
                                    Keep Backups Enable
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Backups;
